import { apiWithPrefix as api } from '../utils/api';

export class CalendarService {
  static async getMonthlyHolidays(year, month, countryCode) {
    const response = await api.get(`/holidays/${year}/${month}/${countryCode}`);
    return response.data;
  }

  static async getInternalHolidays() {
    const response = await api.get('/holidays');
    return response.data;
  }

  static async getGoogleEvents(start, end) {
    const response = await api.get('/google-calendar/events', {
      params: { start, end }
    });
    return response.data;
  }

  static async getGoogleConnectUrl(returnTo) {
    const response = await api.get('/google-calendar/connect-url', {
      params: { returnTo }
    });
    return response.data;
  }

  static async promoteGoogleEvent(data) {
    const response = await api.post('/holidays/promote-google-event', data);
    return response.data;
  }

  static async disconnectGoogleCalendar() {
    const response = await api.delete('/google-calendar/connection');
    return response.data;
  }
}

export default CalendarService;
